export default __webpack_public_path__ + "static/screen_ipad_learn-d88197c7c772608c2dbf96a5996dfc37.png";